export default "__VITE_ASSET__MmN89FX1__"